export const INDUSTRY_COLOR = "#CFB4F7";
export const SCORE_COLOR = "#6221EA";
export const AXIS_COLOR = "#322352";
